import { connect } from 'react-redux';
import {
  getPreviousVersionPosition, getNextVersionPosition, hasPreviousVersion, hasNextVersion, switchVersion,
} from 'store/modules/pageBuilder';
import UndoRedoButtons from '../components/UndoRedoButtons';

const mapStateToProps = state => ({
  previousVersionPosition: getPreviousVersionPosition(state),
  nextVersionPosition: getNextVersionPosition(state),
  isUndoable: hasPreviousVersion(state),
  isRedoable: hasNextVersion(state),
});

const mapDispatchToProps = {
  switchVersions: switchVersion,
};

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  const { previousVersionPosition, nextVersionPosition, ...restOfStateProps } = stateProps;
  const { switchVersions } = dispatchProps;

  return {
    ...ownProps,
    ...restOfStateProps,
    onUndo: () => switchVersions(previousVersionPosition),
    onRedo: () => switchVersions(nextVersionPosition),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps,
)(UndoRedoButtons);
